import type { ProductCardData } from "@/components/ProductCard";

/**
 * Single round-trip fetch of active products + their available stock.
 * Supabase is loaded dynamically so it doesn't ride the initial bundle.
 */
export async function fetchProductsWithStock(limit?: number): Promise<ProductCardData[]> {
  const { supabase } = await import("@/integrations/supabase/client");
  const { data, error } = await supabase.rpc("get_products_with_stock", {
    _limit: limit ?? null,
  } as never);
  if (error) throw error;
  if (!data) return [];
  return (data as Array<Record<string, unknown>>)
    .filter((p) => p.delivery_mode === "on_demand" || Number(p.stock ?? 0) > 0)
    .map((p) => ({

      id: p.id as string,
      name: p.name as string,
      name_en: (p.name_en as string | null) ?? null,
      short_description: p.short_description as string,
      short_description_en: (p.short_description_en as string | null) ?? null,
      price: Number(p.price),
      category: p.category as string,
      sales_count: Number(p.sales_count ?? 0),
      status: p.status as string,
      image_url: (p.image_url as string | null) ?? null,
      stock: Number(p.stock ?? 0),
      custom_category_id: (p.custom_category_id as string | null) ?? null,
      custom_category_name_pt: (p.custom_category_name_pt as string | null) ?? null,
      custom_category_name_en: (p.custom_category_name_en as string | null) ?? null,
      featured: Boolean(p.featured ?? false),
      home_page: Boolean(p.home_page ?? false),
      rank_score: p.rank_score == null ? 0 : Number(p.rank_score),
      supplier_is_official: Boolean(p.supplier_is_official ?? false),
      delivery_mode: (p.delivery_mode as string | null) === "on_demand" ? "on_demand" : "automatic",
    }));
}

